import { Flex, HelpIndicator, Label, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import * as styles from "./DynamicField/styles_vanilla.css";

type LabelWithTooltipProps = {
  fieldName: string;
  label: string;
  tooltip?: {
    content: string;
    placement?: "top" | "bottom" | "left" | "right";
  };
  required?: boolean;
};

const tooltipContent = (content: string) => (
  <Flex>
    <Text variant="regular-md" className={styles.tooltipText}>
      {content}
    </Text>
  </Flex>
);

export const LabelWithTooltip = ({
  fieldName,
  label,
  tooltip,
  required,
}: LabelWithTooltipProps) => (
  <Flex gap={Sizes.XS}>
    <Label required={required}>{label}</Label>
    {tooltip && (
      <div>
        <HelpIndicator
          id={`${fieldName}-tooltip`}
          placement={tooltip.placement ?? "top"}
          content={tooltipContent(tooltip.content)}
          fullWidth
        >
          <Icon
            type="question-circle"
            size="small"
            variant="outline"
            color={Colors.Neutral600}
            data-testid={`${fieldName}-tooltip-icon`}
          />
        </HelpIndicator>
      </div>
    )}
  </Flex>
);
